import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Loader from "../../elements/Loader";
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";

export default function AddCampaign() {
    const params = useParams();
    const { id } = params;
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [initialValues, setInitialValues] = useState({
        name: "",
        description: "",
        budget: "",
        status: "active",
    });

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        description: Yup.string(),
        budget: Yup.number()
            .typeError("Budget must be a number")
            .required("Budget is required"),
        status: Yup.string()
            .oneOf(["active", "inactive", "expired"], "Invalid status")
            .required("Status is required"),
    });

    const getCampaignById = async () => {
        try {
            const response = await ApiService.get(`promotion/campaign/${id}`);
            if (response?.data) {
                const { name, description, budget, status } = response.data;
                setInitialValues({ name, description, budget, status });
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) getCampaignById();
    }, [id]);

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = {
                name: values.name,
                description: values.description,
                budget: values.budget,
                status: values.status,
            };

            if (id) {
                ApiService.put(`promotion/campaign/${id}`, payload)
                    .then((data) => {
                        if (data.msg === "success") {
                            toast.success("Campaign Updated");
                        }
                        navigate("/campaign", { replace: true });
                    })
                    .catch((err) => console.log(err));
            } else {
                ApiService.post("promotion/campaign", payload)
                    .then((data) => {
                        if (data.msg === "success") {
                            toast.success("New Campaign Added");
                        }
                        navigate("/campaign", { replace: true });
                    })
                    .catch((err) => console.log(err));
            }
        } catch (error) {
            console.error("Error saving campaign:", error);
        }
        setSubmitting(false);
    };

    return (
        <div className="row">
            {loading && <Loader />}
            <div className="col-xl-8 col-lg-12 offset-md-2">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">{id ? "Edit" : "Add"} Campaign</h4>
                    </div>
                    <div className="card-body">
                        <div className="basic-form">
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                                enableReinitialize={true}
                            >
                                {({ isSubmitting }) => (
                                    <Form>
                                        <div className="row">
                                            <div className="mb-3 col-md-6">
                                                <label className="form-label">Name</label>
                                                <Field name="name" type="text" className="form-control" />
                                                <ErrorMessage name="name" component="div" className="error-message" />
                                            </div>

                                            <div className="mb-3 col-md-6">
                                                <label className="form-label">Description</label>
                                                <Field as="textarea" name="description" className="form-control" />
                                            </div>

                                            <div className="mb-3 col-md-6">
                                                <label className="form-label">Budget</label>
                                                <Field name="budget" type="number" className="form-control" />
                                                <ErrorMessage name="budget" component="div" className="error-message" />
                                            </div>

                                            <div className="mb-3 col-md-6">
                                                <label className="form-label">Status</label>
                                                <Field as="select" name="status" className="form-control">
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                    <option value="expired">Expired</option>
                                                </Field>
                                                <ErrorMessage name="status" component="div" className="error-message" />
                                            </div>
                                        </div>

                                        <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                            Save
                                        </button>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}